import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import { minWidth } from '../../utils/mediaQueries';

export const Wrapper = styled.div<{ $isMounted: boolean }>`
	align-items: center;
	background: linear-gradient(135deg, #5a5fcc 0%, #5a88cc 100%);
	isolation: isolate;
	justify-content: space-between;
	opacity: ${p => (p.$isMounted ? '1' : '0')};
	padding: 16px 24px;
	text-align: center;
	transform: translate3d(0, ${p => (p.$isMounted ? '0' : '-4px')}, 0);
	transition: ${theme('animation.transition')};

	${minWidth('tablet')} {
		border-radius: 4px;
		display: grid;
		grid-template-columns: 75% 25%;
		padding: 24px;
		text-align: left;
	}
`;

export const Copy = styled.div`
	color: ${palette('white')};
	display: grid;
	grid-row-gap: 4px;
	padding-bottom: 16px;

	${minWidth('tablet')} {
		padding-bottom: 0;
		padding-right: 16px;
	}
`;

export const ButtonWrapper = styled.div`
	text-align: right;
`;
